import { onVisibilityChange } from '@/_helpers/utils.js';
import Axios from 'axios';

export default {
  data() {
    return {
      isShowContent: true,
      isBlurred: false,
      ctrlDown: false
    };
  },

  mounted() {
    document.addEventListener('keydown', e => {
      if (e.key == 'Meta' || e.key == 'Control') this.ctrlDown = true;

      this.keyPressingEvents(e);
    });
    document.addEventListener('keyup', e => {
      if (e.key == 'Meta' || e.key == 'Control') this.ctrlDown = false;

      this.isShowContent = true;
    });
    document.addEventListener('contextmenu', e => e.preventDefault());

    onVisibilityChange(visible => {
      if (visible) {
        this.isBlurred = false;
      } else {
        this.sendBlurEvent();
        this.isBlurred = true;
      }
    });
  },

  destroyed() {
    document.removeEventListener('keydown', e => this.keyPressingEvents(e));
    document.removeEventListener('keyup', () => (this.isShowContent = true));
    document.removeEventListener('contextmenu', e => e.preventDefault());
  },

  methods: {
    sendBlurEvent() {
      if (this.hasAnticheating) {
        let params = { event: 'focus-changed' };

        if (this.isQuestionsOne) {
          params.question_id = this.question.id;
        }

        Axios.put(`/1.0/interviews/${this.token}/tests/candidate-event`, params);
      }
    },

    keyPressingEvents(e) {
      if (
        e.key === 'F13' ||
        (this.ctrlDown && (e.key === 'c' || e.key === 'C')) ||
        (this.ctrlDown && (e.key === 'c' || e.key === 'C'))
      ) {
        this.isShowContent = false;
        this.stopPrntScr();
        e.preventDefault();
        return false;
      }
    },

    stopPrntScr() {
      var inpFld = document.createElement('input');
      inpFld.setAttribute('value', '.');
      inpFld.setAttribute('width', '0');
      inpFld.style.height = '0px';
      inpFld.style.width = '0px';
      inpFld.style.border = '0px';
      document.body.appendChild(inpFld);
      inpFld.select();
      document.execCommand('copy');
      inpFld.remove(inpFld);
      console.log('Sorry, screenshots prohibited!');
    }
  }
};
